let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f7t4l")).then(() => parcelRequire('aDUGY'));